module.exports = __webpack_public_path__ + "img/logo_NC_Digital-04.8ac36d38.png";